/**
 * Get amount and convert it to supplied decimal places.
 *
 * @param  {number}  amount
 * @param  {number}  decimal_places
 * @return {number}
 */
export function getNumbersWithDecimalPlaces(amount, decimal_places = 2) {
  if (!amount || isNaN(parseFloat(amount)) || Number.isInteger(amount)) return amount;

  if (typeof amount === 'string') {
    amount = parseFloat(amount);
  }

  return amount.toFixed(decimal_places);
}

/**
 * Add 1000th place comma and 2 point decimal to amount
 * @param {*} amount
 * @returns {string}
 */
export function getNumberWithCommas(amount, maximumFractionDigits = 2) {
  if (isNaN(amount)) return amount;

  if (typeof amount === 'string') {
    amount = Number(amount);
  }

  return amount.toLocaleString('en-US', { maximumFractionDigits: maximumFractionDigits });
}

/**
 * Add 1000th place k and 2 point decimal to amount
 * @param {*} amount
 */
export function Kformat(amount, maximumFractionDigits = 2) {
  if (isNaN(amount)) return amount;

  if (typeof amount === 'string') {
    amount = Number(amount);
  }

  return Math.abs(amount) > 999
    ? Math.sign(amount) * (Math.abs(amount) / 1000).toFixed(maximumFractionDigits) + ' K'
    : Math.sign(amount) * (Math.abs(amount)).toFixed(maximumFractionDigits);
}

export const roundUp = (value) => {
  return Math.round((value + Number.EPSILON) * 100) / 100;
};

export const getAmountChangePercent = (oldAmount, newAmount) => {
  if (!parseFloat(oldAmount)) {
    return '0';
  }

  if (isNaN(parseFloat(oldAmount)) || isNaN(parseFloat(newAmount))) {
    return '0';
  }

  if (!parseFloat(newAmount) && parseFloat(oldAmount)) {
    return '0';
  }

  // change price/amount = new - old
  // if change value is negative then negative incerement else positive
  const change_amount = newAmount - oldAmount;
  // change percentage = (change_amount / old total) * 100
  const change_percentage = (change_amount / oldAmount) * 100;
  return getNumbersWithDecimalPlaces(change_percentage);
};
